module.exports = __webpack_public_path__ + "img/2.2_Chief-Investigators_1_Conigrave.1a274c828e26e3bb1bb11245f0e37610.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.2_Chief-Investigators_1_Conigrave.png
// module id = 748
// module chunks = 0